import React from "react";

export default function SQLServer_NULLIF() {
  return (
    <div className="p-4">
      <h1 className="text-2xl font-bold">SQLServer_NULLIF</h1>
      <p>This is the SQLServer_NULLIF component generated from the SQL JSON.</p>
    </div>
  );
}
